export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center">
                <i className="ri-plant-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">财税知识森林</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              专业的财税知识库平台，为您提供全面的法规政策、深度解读、实务案例和行业动态
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">知识板块</h4>
            <ul className="space-y-3">
              <li><a href="/knowledge/regulations" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">法规政策</a></li>
              <li><a href="/knowledge/interpretation" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">政策解读</a></li>
              <li><a href="/knowledge/cases" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">实务案例</a></li>
              <li><a href="/knowledge/industry" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">行业动态</a></li>
              <li><a href="/knowledge/news" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">最新资讯</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">快速链接</h4>
            <ul className="space-y-3">
              <li><a href="/about" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">关于我们</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">联系我们</a></li>
              <li><a href="/help" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">帮助中心</a></li>
              <li><a href="/privacy" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">隐私政策</a></li>
              <li><a href="/terms" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer whitespace-nowrap">使用条款</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">联系方式</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-emerald-400 mt-1"></i>
                <div>
                  <div className="text-xs text-gray-500 mb-1">邮箱</div>
                  <a href="mailto:contact@taxknowledge.com" className="text-sm text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                    contact@taxknowledge.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-emerald-400 mt-1"></i>
                <div>
                  <div className="text-xs text-gray-500 mb-1">电话</div>
                  <a href="tel:400-888-8888" className="text-sm text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer whitespace-nowrap">
                    400-888-8888
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-emerald-400 mt-1"></i>
                <div>
                  <div className="text-xs text-gray-500 mb-1">地址</div>
                  <span className="text-sm text-gray-400">
                    北京市朝阳区金融街88号
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              © 2024 财税知识森林. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}